import React from 'react';

import PresetGrid from './PresetGrid';

// One-click layout presets for the multi-price picker. Every preset sets the
// four layout theme fields plus the checkmark element toggle — see
// PresetGrid for how applying and highlighting work.

const BASE = 'variables.elements.product.pricePicker';
const LAYOUT_KEYS = ['layout', 'horizontalAlign', 'verticalAlign', 'pwywDisplay'];
const CHECKMARK_KEY = 'option.indicator.enabled';

export const PRESETS = [
  {
    key: 'list',
    name: 'List',
    values: {
      layout: 'list',
      horizontalAlign: 'left',
      verticalAlign: 'top',
      pwywDisplay: 'inline',
    },
    extras: { [CHECKMARK_KEY]: true },
  },
  {
    key: 'grid',
    name: 'Grid',
    values: {
      layout: 'grid-2',
      horizontalAlign: 'center',
      verticalAlign: 'center',
      pwywDisplay: 'inline',
    },
    extras: { [CHECKMARK_KEY]: true },
  },
  {
    key: 'donation',
    name: 'Donation',
    values: {
      layout: 'grid-3',
      horizontalAlign: 'center',
      verticalAlign: 'center',
      pwywDisplay: 'button',
    },
    extras: { [CHECKMARK_KEY]: false },
  },
  {
    key: 'open',
    name: 'Open amount',
    values: {
      layout: 'grid-3',
      horizontalAlign: 'center',
      verticalAlign: 'center',
      pwywDisplay: 'standalone',
    },
    extras: { [CHECKMARK_KEY]: true },
  },
];

function Thumb({ kind }) {
  if (kind === 'list') {
    return (
      <div className="w-full space-y-1.5">
        <div className="h-3 w-full rounded bg-gray-200 dark:bg-accent" />
        <div className="h-3 w-full rounded bg-gray-200 dark:bg-accent" />
      </div>
    );
  }
  if (kind === 'grid') {
    return (
      <div className="grid w-full grid-cols-2 gap-1.5">
        <div className="h-[13px] rounded bg-gray-200 dark:bg-accent" />
        <div className="h-[13px] rounded bg-gray-200 dark:bg-accent" />
        <div className="h-[13px] rounded bg-gray-200 dark:bg-accent" />
        <div className="h-[13px] rounded bg-gray-200 dark:bg-accent" />
      </div>
    );
  }
  if (kind === 'donation') {
    return (
      <div className="w-full space-y-1.5">
        <div className="flex gap-1.5">
          <div className="h-3 flex-1 rounded bg-gray-200 dark:bg-accent" />
          <div className="h-3 flex-1 rounded bg-gray-200 dark:bg-accent" />
          <div className="h-3 flex-1 rounded bg-gray-800 dark:bg-primary" />
        </div>
        <div className="h-[14px] w-full rounded border border-gray-300 dark:border-border bg-white dark:bg-background" />
      </div>
    );
  }
  return (
    <div className="w-full space-y-1.5">
      <div className="flex gap-1.5">
        <div className="h-3 flex-1 rounded bg-gray-200 dark:bg-accent" />
        <div className="h-3 flex-1 rounded bg-gray-200 dark:bg-accent" />
        <div className="h-3 flex-1 rounded bg-gray-200 dark:bg-accent" />
      </div>
      <div className="h-[18px] w-full rounded-md border-2 border-gray-400 dark:border-border bg-white dark:bg-background" />
    </div>
  );
}

export default function PricePickerPresets({ values, setFieldValue }) {
  return (
    <PresetGrid
      base={BASE}
      keys={LAYOUT_KEYS}
      presets={PRESETS}
      values={values}
      setFieldValue={setFieldValue}
      renderThumb={kind => <Thumb kind={kind} />}
    />
  );
}
